import { render } from "./ContactUsView.vue?vue&type=template&id=6050bfc8&scoped=true"
import script from "./ContactUsView.vue?vue&type=script&lang=js"
export * from "./ContactUsView.vue?vue&type=script&lang=js"

import "./ContactUsView.vue?vue&type=style&index=0&id=6050bfc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6050bfc8"]])

export default __exports__